module.exports = __webpack_public_path__ + "img/IMG_6799.80a8ec9d.jpg";